<div class="row cal-title">
  <div class="col-md-11">
    <h4><b>{{ 'pages.rateCalculatorPage.rateCalculator' | translate }}</b></h4>
  </div>
</div>
<div class="row cal-box"></div>

<div class="row padd-lft5 padd-top3">
  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">{{ 'common.accountNumber' | translate }}</label>
      <select class="form-control" (change)="selectAccount($event.target.value)">
        <option *ngFor="let item of userAccounts" selected="{{item.IsDefault ==true ? 'selected' : '' }}">{{item.Number}}</option>
      </select>
      <span [innerHtml]="validatorObj.account.message" style="color:#dc291e"></span>
    </div>
  </div>
</div>
<div class="row padd-lft5">
  <div class="col-md-3">
    <div class="form-group">
      <label class="label-control">{{ 'common.from' | translate }}</label>
      <div class="inner-addon right-addon">
        <i class="glyphicon armx-sort"></i>
        <global-drop-down-list [key]="'key'"
                               [placeHolder]="'pages.rateCalculatorPage.fromPlaceholder' | translate"
                               [ddlContent]="countries"
                               (selectedVal)="onCountrySelect($event)"
                               [selectedValue]="uiFromCountryCode"
                               [isDisabled]="true">
        </global-drop-down-list>
      </div>
    </div>
  </div>
</div>
<div class="row padd-lft5">
  <div class="col-md-3">
    <div class="form-group">
      <label class="label-control">{{ 'common.to' | translate }}</label>
      <div class="inner-addon right-addon">
        <i class="glyphicon armx-sort"></i>
        <global-drop-down-list [key]="'key'"
                               [placeHolder]="'pages.rateCalculatorPage.toPlaceholder' | translate"
                               [ddlContent]="countries"
                               (selectedVal)="onDestinationSelect($event)"
                               [focus]="true">
        </global-drop-down-list>
        <span [innerHtml]="validatorObj.destination.message" style="color:#dc291e"></span>
      </div>
    </div>
  </div>
</div>
<div class="row padd-lft5">
  <div class="col-md-1">
    <div class="form-group">
      <label class="label-control">{{ 'common.weight' | translate }}</label>
      <div class="inner-addon right-addon">
        <input type="number" class="form-control" [ngModel]="calculateRateRequest.Weight?.Value" (ngModelChange)="calculateRateRequest.Weight.Value=$event" min="0"  (blur)="checkValidation()" />
        <span [innerHtml]="validatorObj.weight.message" style="color:#dc291e"></span>
      </div>
    </div>
  </div>
  <div class="col-md-1 col-md-offset-1">
    <div class="form-group">
      <label class="label-control">{{ 'common.unit' | translate }}</label>
      <div class="inner-addon right-addon">
        <div class="form-group">
          <select class="form-control" disabled="disabled" [ngModel]="calculateRateRequest.Weight?.Unit" (ngModelChange)="calculateRateRequest.Weight.Unit=$event">
            <option value="KG">Kg</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="mrgin-lft">
    <div class="col-md-2" *ngFor="let item of productTypes; index as i">
      <button class="btn btn-lg btn-mode" (click)="createShipment(item.ProductType.Code)">
        <span class="box-title">{{item.ProductType?.Code}}</span>
        <p class="sub-box">{{item.ProductType?.Description}}</p>
        <p class="sub-box" style="color:#000">{{ 'pages.rateCalculatorPage.amount' | translate }}: {{item.RateDetails?.TotalAmount}} {{item.RateDetails?.CurrencyCode}}</p>
      </button>
    </div>
  </div>
</div>
<div class="row padd-lft5 padd-top3 padd-bottom3">
  <div class="col-md-1 padd-top10p">
    <button class="btn btn-primary" (click)="calculateRate()">{{ 'common.calculate' | translate }}</button>
  </div>
  <!--<div class="col-md-1 padd-top10p">
    <button class="btn btn-default {{productTypes ? '' : 'btn-disabled'}}" (click)="createShipment()">Create shipment</button>
  </div>-->

</div>


